module.exports = __webpack_public_path__ + "img/2017-12-23.7cccf6fc.jpg";